import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { ABContext } from '../../../../contexts/ABContext';
import { HotelSearchRoom, HotelType, RoomType } from '../../../../types/HotelType';
import { BookingSiteOperated } from '../../../Misc/BookingSiteOperated/BookingSiteOperated';
import { HotelRoomModal } from '../HotelRoomModal/HotelRoomModal';
import styles from './ListRoomItem.module.scss';
import { DatesSearchContext, DatesSearchContextType } from '../../../../contexts/DatesSearchContext';
import { CartType } from '../../../../types/CartType';
import { CartAPI } from '../../../../api/CartAPI';
import { ListHotelImageCarousel } from "../ListHotelImageCarousel/ListHotelImageCarousel";
import { format } from 'date-fns';
import { DataLayerAPI } from '../../../../api/DataLayerAPI';
import { differenceInDays } from "date-fns";

// CRO-1240
import { PricePerDate } from '../../../Misc/PricePerDate/PricePerDate';

type ListRoomItemProps = {
  room: RoomType,
  hotel: HotelType
  roomNumber: number,
  hotelSearchRooms: HotelSearchRoom[],
  cart: CartType,
  cartAPI?: CartAPI,
  tabIndex: number,
  setTabIndex: Dispatch<SetStateAction<number>>,
}

export function ListRoomItem({ room, hotel, roomNumber, hotelSearchRooms, cartAPI, cart, tabIndex, setTabIndex}: ListRoomItemProps) {
  // CRO-1240-Price-per-night
  const ab = useContext(ABContext);
  const isCro1240 = ab.isActiveTest('CRO-1240-Price-per-night');

  const [_popupOpen, setPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { datesSearch } = useContext<DatesSearchContextType>(DatesSearchContext);
  const [ stayLength ] = useState<number>(differenceInDays(datesSearch[1],datesSearch[0]))

  const formatedDate = datesSearch.map(date => format(date,'yyyy-MM-dd'));
  const dataLayerAPI = new DataLayerAPI();

  let childAges: number[] = [];
  let numAdults = 0;
  let numChildren = 0;
  let numInfants = 0;

  if (hotelSearchRooms !== undefined && hotelSearchRooms.length > 0) {
    if (hotelSearchRooms[+roomNumber - 1] !== undefined) {
      childAges = hotelSearchRooms[+roomNumber - 1].childrenAges;
      numAdults = hotelSearchRooms[+roomNumber - 1].adultsQty;
      numChildren = hotelSearchRooms[+roomNumber - 1].childrenQty;
      numInfants = hotelSearchRooms[+roomNumber - 1].infantsQty;
    } else {
      childAges = [];
      numAdults = 0;
      numChildren = 0;
      numInfants = 0;
    }
  }

  const button = (cart: CartType, room: RoomType, roomNumber: number, hotel: HotelType, numAdults: number, numChild: number, numInfant: number, ChildAges: number[], date1: string, date2: string) => {
    // this the product id of the room which will = ticket_id in the cart
    const roomProductId: string = Object.keys(room.packages)[0]
    const hotelInCart = cart.data.tickets.map((ticket) => ticket.data.attraction_title)
    const cartItemId = cart.data.tickets.map((ticket) => ticket.ticket_id)
    const tabLength =  hotelSearchRooms.length
    const currentTab = roomNumber - 1

    const buttonText = 'Select';

    const tabSetter = () => {
      if (currentTab < tabLength - 1) {
        setTabIndex(currentTab + 1)
      }
      if (currentTab === tabLength - 1) {
        return ;
      }
    }

    // this is returning an array in which at the 0 index will be cart item with the same product id as the room if the room is added to the cart
    const ticketIdInCart = cart.data.tickets.filter((ticket) =>{
      if (ticket.tags.includes(`room-${roomNumber}`)) {
        return ticket.ticket_id
      }
    })

  // Add to Cart Button
    const addToCartButton = <button key={roomNumber} className={styles.btn} onClick={async () => {
      setLoading(true)
      await cartAPI?.addRoom(room, roomNumber, hotel, numAdults, numChild, numInfant, ChildAges, date1, date2)
      setLoading(false)
      tabSetter()
    }}
    >{buttonText}</button>

  // Switch to this Hotel Button
    const switchToThisHotelButton = <button key={roomNumber} className={styles.btn} onClick={async () => {
      setLoading(true)
      dataLayerAPI.logModifyCart(cart.data.tickets,roomNumber)
      await cartAPI?.removeAll(cartItemId)
      await cartAPI?.addRoom(room, roomNumber, hotel, numAdults, numChild, numInfant, ChildAges, date1, date2)
      setLoading(false)
      }}>{buttonText}</button>

  // Loading Button
    const loadingButton = <button key={roomNumber} className={styles.btn} disabled>...Loading</button>

  // Selected button
    const selectedButton = <button key={roomNumber} className={styles.selected} disabled >Selected</button>

  // Add to SwitchToThisRoom Button
    const swtichToThisRoomButton = <button key={roomNumber} className={styles.btn} onClick={async () => {
      setLoading(true)
      await cartAPI?.removeRoom(roomNumber)
      dataLayerAPI.logModifyCart(cart.data.tickets,roomNumber)
      await cartAPI?.addRoom(room, roomNumber, hotel, numAdults, numChild, numInfant, ChildAges, date1, date2)
      setLoading(false)
    }}
    >{buttonText}</button>

  // Loading Button
    if (loading || cart.loading) return loadingButton

    if (ticketIdInCart.length > 0) {

      if (!hotelInCart.includes(hotel.title)) return switchToThisHotelButton

      return (ticketIdInCart[0].ticket_id === roomProductId) ? selectedButton : swtichToThisRoomButton

    }

    return addToCartButton
  }

  return (
    <div key={room.product_id} className={styles.list}>
      <div className={styles.product}>
        <div className={styles.productImage}>
          <div className={styles.img}>
            <ListHotelImageCarousel photos={room.photos} />
          </div>
        </div>
        <div className={styles.productDetails}>
          <h3>{room.title}</h3>
          <p className={styles.descriptionText}>{room.desc_short}</p>
          <HotelRoomModal room={room} hotel={hotel} />
        </div>
      </div>
      <div className={`${styles.footer} ${styles.roomsFooter}`}>
        {hotel.internal.persuasion_message && (
        <div className={styles.text}>{hotel.internal.persuasion_message}</div>
        )}
        <div className={`${styles.footerPricingCta} ${styles.roomsCta}`}>
          <div className={styles.productPricing}>
            {(isCro1240 && +room.price > 0) ? (
              <PricePerDate totalPrice={room.price} numOfDates={stayLength} productType='room' />
            ) : (!isCro1240 && +room.price > 0) ? (
                <p className={styles.priceStyles}>
                  <strong className={styles.fromPrice}>£{room.price}</strong>
                  <span className={styles.totalStay}>Total for {stayLength}-night stay</span>
                  <em className={styles.textBelow}>Includes taxes and charges</em>
                </p>
             ) : ''
            }
          </div>
          <div className={styles.callToAction}>
          {+room.price > 0 ? (
              <>
                {button(cart, room, roomNumber, hotel, numAdults, numChildren, numInfants, childAges, formatedDate[0], formatedDate[1])}
              </>
            ) : ''
            }
          </div>
        </div>
        <BookingSiteOperated placement="room" />
      </div>
    </div>
  );
}

